module.exports = __webpack_public_path__ + "img/1-5.617f2897.png";